import type { Step } from "react-joyride";

/**
 * Versione 2 (2026-09-12): il questionario d'apertura, «Nuova consulenza» e gli
 * esempi allineati alle operazioni che il portale sa aprire oggi.
 */
export const chatVersion = 2;

export const chatSteps: Step[] = [
  {
    target: '[data-tour="chat-container"]',
    title: "Si parte dalle domande",
    content: (
      <p>
        Ogni consulenza comincia da quattro domande: che cliente è, mercato, che
        operazione serve, dove va la bolletta. Poi si continua a parlare
        liberamente.
      </p>
    ),
    placement: "center",
    skipBeacon: true,
  },
  {
    target: '[data-tour="message-input"]',
    title: "Scrivi la richiesta",
    content: (
      <div>
        <p>Descrivi cosa serve all'AI. Esempi reali:</p>
        <ul style={{ marginTop: 8, paddingLeft: 18 }}>
          <li><em>"Fammi vedere le offerte luce"</em></li>
          <li><em>"Voltura per un cliente che subentra in affitto"</em></li>
          <li><em>"Il contatore è chiuso, serve una riattivazione"</em></li>
        </ul>
      </div>
    ),
    placement: "top",
    skipBeacon: true,
  },
  {
    target: '[data-tour="upload-button"]',
    title: "Carica la bolletta",
    content: (
      <p>
        La graffetta allega <strong>foto o PDF</strong> — anche più d'uno
        insieme. L'assistente ne ricava POD o PDR, consumi e intestatario.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
  {
    target: '[data-tour="chat-nuova"]',
    title: "Un altro cliente",
    content: (
      <p>
        <strong>Nuova consulenza</strong> chiude quella in corso e riparte dalle
        domande. Senza, i dati del cliente precedente restano in mezzo.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: '[data-tour="bot-message"] [data-tour="flag"]',
    title: "Segnala una risposta sbagliata",
    content: (
      <p>
        Passando sul messaggio compare una{" "}
        <strong style={{ color: "#dc2626" }}>bandierina</strong>: la segnalazione
        arriva al team con lo storico e gli allegati, così l'errore si può
        riprodurre.
      </p>
    ),
    placement: "left",
    skipBeacon: true,
  },
];
